// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3oqjA","legacyBtn":"MutateMid_legacyBtn__1rmFG"};